import type { SVGProps } from 'react';
const SvgIconDisclosureDoubleRightSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="M8.02 11.336a.75.75 0 1 0 1.13.985l3.33-3.829a.75.75 0 0 0 0-.984L9.15 3.679a.75.75 0 1 0-1.13.985L10.424 8z" />
    <path fill="currentColor" d="M3.52 11.336a.75.75 0 1 0 1.13.985l3.33-3.829a.75.75 0 0 0 0-.984L4.65 3.679a.75.75 0 1 0-1.13.985L5.924 8z" />
  </svg>
);
export default SvgIconDisclosureDoubleRightSmall;
